import ScrollIn from './common/scroll';
import BgLight from './common/bglight';
import TapAnimation from './common/tap_animation';
import Transition from './common/transition';
import Gnav from './common/gnav';
import ProtectImg from './common/protectimg.es6';
/* import MoviePlayer from './common/movie'; */

const scrollin = new ScrollIn();
const bglight = new BgLight();
const tapanimation = new TapAnimation();
const transition = new Transition();
const gnav = new Gnav();
const protectImg = new ProtectImg();
/* const movieplayer = new MoviePlayer(); */

